// Mutation hook - modyfikacja aktywnosci transakcji
// PUT /api/ui/sales-crm/deals/{id}/activities/{activityId}

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IPutDealActivityRequest } from 'api/types/deals';

interface IPutDealActivityResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

interface IPutDealActivityVariables {
  dealId: number;
  activityId: number;
  body: IPutDealActivityRequest;
}

const putDealActivity = ({ dealId, activityId, body }: IPutDealActivityVariables): Promise<IPutDealActivityResponse> =>
  axios.put(`/sales-crm/deals/${dealId}/activities/${activityId}`, body);

export const usePutDealActivity = (
  options?: UseMutationOptions<IPutDealActivityResponse, IError, IPutDealActivityVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IPutDealActivityResponse, IError, IPutDealActivityVariables>(putDealActivity, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(['sales-crm-deal-activities', variables.dealId]);
      await queryClient.refetchQueries(['sales-crm-deal-activities', variables.dealId]);
      options?.onSuccess?.(data, variables, context);
    },
  });
};
